// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import TextField from "../../../../components/TextField";
import ImageCase from "../../../../components/ImageCase";
import Button from "../../../../components/Button";
import Divider from "../../../../components/Divider";

// MARK: Stores
import BannerStore from "../../../../stores/BannerStore";
import { routerStore } from "../../../../stores/_rootStore";

// MARK: Resources
import strings from "../../../../resources/strings";
import { match as Match } from "react-router";

interface IProps {
	bannerStore: BannerStore;
	match: Match<{ bannerId?: string }>;
}

@inject("bannerStore")
@observer
export default class BannerCreateOrEdit extends React.Component<IProps> {
	public componentDidMount = async () => {
		const bannerId = this.props.match.params.bannerId;
		if (bannerId) {
			await this.props.bannerStore.getBanner(bannerId);
		}
	};

	public render() {
		const { bannerStore } = this.props;
		return (
			<div className="bannerCreateOrEdit">
				{!bannerStore.loading && (
					<div className="bannerCreateOrEditWrapper">
						<h1 className="bannerCreateOrEditTitle">{bannerStore.selectedBanner ? strings.banner.createOrEdit.title.edit : strings.banner.createOrEdit.title.new}</h1>
						<div className="bannerFormContainer">
							<h2>{strings.banner.createOrEdit.sections.data}</h2>
							<TextField
								label={strings.banner.createOrEdit.fields.nick}
								name="nick"
								value={bannerStore.nick}
								onChange={bannerStore.handleValueChange}
								disabled={bannerStore.loading}
								required={true}
							/>
							<TextField
								label={strings.banner.createOrEdit.fields.title}
								name="title"
								value={bannerStore.title}
								onChange={bannerStore.handleValueChange}
								disabled={bannerStore.loading}
								required={true}
							/>
							<TextField
								label={strings.banner.createOrEdit.fields.description}
								name="description"
								multiline={true}
								value={bannerStore.description}
								onChange={bannerStore.handleValueChange}
								disabled={bannerStore.loading}
							/>
							<TextField
								label={strings.banner.createOrEdit.fields.url}
								name="url"
								value={bannerStore.url}
								onChange={bannerStore.handleValueChange}
								disabled={bannerStore.loading}
							/>
						</div>
						<Divider className="divider" />
						<ImageCase
							title={strings.banner.createOrEdit.fields.imageTitle}
							onAddItem={bannerStore.imageService.selectSingleImage}
							onRemoveItem={bannerStore.imageService.removeImage}
							onReloadItem={bannerStore.imageService.reloadImage}
							imageUploaders={bannerStore.imageService.singleImageUploader}
						/>
						<Divider className="divider" />
						<ImageCase
							title={strings.banner.createOrEdit.fields.mobileImageTitle}
							onAddItem={bannerStore.mobileImageService.selectSingleImage}
							onRemoveItem={bannerStore.mobileImageService.removeImage}
							onReloadItem={bannerStore.mobileImageService.reloadImage}
							imageUploaders={bannerStore.mobileImageService.singleImageUploader}
						/>
						<div className="buttonsContainer">
							<Button
								onClick={() => bannerStore.createOrEditBanner()}
								style={{ backgroundColor: "#0081B0", color: "white" }}
							>
								{strings.banner.createOrEdit.buttons.save}
							</Button>
							<Button
								onClick={() => routerStore.push("/dashboard/banners")}
							>
								{strings.banner.createOrEdit.buttons.back}
							</Button>
						</div>
					</div>
				)
				}
			</div>
		);
	}
}
